import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_MISC_CONTRACTS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_MISC_CONTRACT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_MISC_CONTRACT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_MISC_CONTRACT:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_MISC_CONTRACT:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
